export default __webpack_public_path__ + "static/media/WEG3.2a8ff4bd.jpg";